var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import BaseLoading from '../components/loading/BaseLoading';
function withLazyLoad(loader, settings) {
    if (settings === void 0) { settings = { fallback: _jsx(BaseLoading, {}) }; }
    var fallback = settings.fallback;
    var LazyComponent = lazy(loader);
    var LazyLoadWrapper = function (_a) {
        var props = __rest(_a, []);
        return (_jsx(Suspense, { fallback: fallback, children: _jsx(LazyComponent, __assign({}, props)) }));
    };
    return LazyLoadWrapper;
}
export default withLazyLoad;
